const getContinentByLocale = locale => (
    ['en_us', 'es_us'].indexOf(locale.toLowerCase()) === -1 ? 'europe' : 'north_america'
);

export { getContinentByLocale };
